module.exports = {
  en: { id: "en", name: "English", siteId: 1 },
  es: { id: "es", name: "Español", siteId: 6 },
  // pt: { id: "pt", name: "Português", siteId: 2 },
  zh: { id: "zh", name: "简体中文", siteId: 5, code: "zh-Hans" },
  // ru: { id: "ru", name: "Русский", siteId: 4 },
  de: { id: "de", name: "Deutsch", siteId: 3 },
};
